// SCA Construtora — Site content (extraído integralmente do fluxograma oficial)

export const COMPANY = {
  name: "SCA Construtora",
  short: "SCA",
  tagline: "Engenharia organizada.",
  founded: "Piracicaba — SP",
  cnpj: "33.692.184/0001-00", // placeholder — atualizar quando informado
  address: {
    line1: "Rua Voluntários de Piracicaba, 367",
    line2: "Sala 03 — Centro",
    city: "Piracicaba — SP",
    zip: "13400-290",
    mapsQuery:
      "Rua+Volunt%C3%A1rios+de+Piracicaba+367+Centro+Piracicaba+SP",
  },
  phone: "+55 (19) 3432-2732",
  phoneRaw: "551934322732",
  whatsapp: "+55 (19) 99747-6891",
  whatsappRaw: "5519997476891",
  email: "contato@scaconstrutora.com.br",
  hours: "Seg. a Sex. — 08h às 18h",
  socials: {
    instagram: "https://www.instagram.com/scaconstrutora/",
    facebook: "https://www.facebook.com/scaconstrutora",
    linkedin: "https://www.linkedin.com/company/scaconstrutora",
  },
  logos: {
    positive:
      "https://customer-assets.emergentagent.com/job_16e1819c-371f-47dc-900b-ad4d377df2d0/artifacts/x0mniwmo_dominante%20horizontal_positivo.png",
    negative:
      "https://customer-assets.emergentagent.com/job_16e1819c-371f-47dc-900b-ad4d377df2d0/artifacts/jd58fwom_dominante%20horizontal_negativo%20fundo%20cinza%20escuro.png",
  },
};

export const WHATSAPP_URL = (msg = "Olá, gostaria de uma avaliação técnica.") =>
  `https://wa.me/${COMPANY.whatsappRaw}?text=${encodeURIComponent(msg)}`;

// Curated industrial / engineering imagery
export const IMAGES = {
  heroPrimary:
    "https://images.unsplash.com/photo-1535732759880-bbd5c7265e3f?auto=format&fit=crop&w=2400&q=85",
  heroAlt:
    "https://images.pexels.com/photos/5504388/pexels-photo-5504388.jpeg?auto=compress&cs=tinysrgb&w=2000",
  industrial:
    "https://images.unsplash.com/photo-1508450859948-4e04fabaa4ea?auto=format&fit=crop&w=2000&q=85",
  steelFrame:
    "https://images.pexels.com/photos/31197870/pexels-photo-31197870.jpeg?auto=compress&cs=tinysrgb&w=2000",
  commercial:
    "https://images.pexels.com/photos/30920930/pexels-photo-30920930.jpeg?auto=compress&cs=tinysrgb&w=2000",
  concrete:
    "https://images.unsplash.com/photo-1522743791393-522312deeebf?auto=format&fit=crop&w=2000&q=85",
  residential:
    "https://images.unsplash.com/photo-1543067361-9bf996edf6ff?auto=format&fit=crop&w=2000&q=85",
  management:
    "https://customer-assets.emergentagent.com/job_engenharia-sca-elite/artifacts/j4f251l4_AdobeStock_19943828311.jpg",
  rebar:
    "https://images.unsplash.com/photo-1531834685032-c34bf0d84c77?auto=format&fit=crop&w=2400&q=85",
  metalStructure:
    "https://images.unsplash.com/photo-1509024368907-57294758cfc5?auto=format&fit=crop&w=2400&q=85",
  blueprint:
    "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=2400&q=85",
  helmet:
    "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=2000&q=85",
  warehouse:
    "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?auto=format&fit=crop&w=2000&q=85",
  highrise:
    "https://images.unsplash.com/photo-1486325212027-8081e485255e?auto=format&fit=crop&w=2400&q=85",
  facade:
    "https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?auto=format&fit=crop&w=2400&q=85",
  // Editorial banners (Home 4-banner section)
  bannerQuemSomos:
    "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?auto=format&fit=crop&w=2400&q=85",
  bannerObrasIndustriais:
    "https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=2400&q=85",
  bannerMetodologia:
    "https://images.pexels.com/photos/8961065/pexels-photo-8961065.jpeg?auto=compress&cs=tinysrgb&w=2400",
  bannerContato:
    "https://images.pexels.com/photos/3760067/pexels-photo-3760067.jpeg?auto=compress&cs=tinysrgb&w=2400",
  fachada:
    "https://customer-assets.emergentagent.com/job_engenharia-sca-elite/artifacts/3w7jwe8w_FACHADA.jfif",
};

// ---------- SERVIÇOS ----------
export const SERVICES = [
  {
    slug: "obras-industriais",
    number: "01",
    title: "Obras Industriais",
    short: "Construção de galpões, ampliações fabris e estruturas operacionais.",
    h1: "Execução de obras industriais com organização, segurança e controle técnico",
    intro:
      "Projetos industriais exigem alto nível de planejamento, integração técnica e controle operacional. Atrasos, falhas de execução e retrabalho impactam diretamente a operação da empresa.",
    sections: [
      {
        title: "Como a SCA atua em obras industriais",
        items: [
          "Construção completa de galpões industriais",
          "Ampliação e modernização de plantas fabris",
          "Adequações operacionais e funcionais",
          "Estruturas metálicas e estruturas em concreto",
          "Infraestrutura técnica (elétrica, hidráulica, ar comprimido, dados)",
          "Obras de apoio industrial (vestiários, refeitórios, áreas técnicas)",
          "Áreas de docas, expedição e armazenagem",
          "Pavimentações industriais de alta performance",
        ],
      },
      {
        title: "O que garantimos",
        items: [
          "Planejamento executivo estruturado por marcos",
          "Controle rigoroso de cronograma físico-financeiro",
          "Gestão organizada da execução com canteiro padronizado",
          "Segurança operacional e protocolos de SST",
          "Conformidade normativa (ABNT, NRs, ambiental)",
          "Redução comprovada de riscos, atrasos e retrabalhos",
          "Comunicação técnica contínua com o cliente",
          "Entrega validada com documentação técnica completa",
        ],
      },
    ],
    cta: "Solicitar reunião técnica",
    image: IMAGES.industrial,
    seo: {
      title: "Obras Industriais com Planejamento e Controle | SCA Construtora",
      description:
        "Execução de obras industriais, ampliações fabris e adequações estruturais com controle técnico e cumprimento rigoroso de prazos.",
    },
  },
  {
    slug: "reformas-industriais",
    number: "02",
    title: "Reformas Industriais",
    short: "Modernização e ampliação com mínimo impacto operacional.",
    h1: "Reformas industriais com planejamento, controle e mínimo impacto operacional",
    intro:
      "A reforma industrial exige muito mais do que execução técnica. Ela exige planejamento detalhado, coordenação operacional e capacidade de atuar em ambientes produtivos sem comprometer segurança, produtividade e cronograma.",
    sections: [
      {
        title: "Como a SCA atua em reformas industriais",
        items: [
          "Ampliação de estruturas industriais",
          "Adequações operacionais",
          "Reformas estruturais",
          "Readequação de layouts produtivos",
          "Modernização de instalações",
          "Intervenções técnicas em áreas operacionais",
          "Adequações conforme normas técnicas",
          "Obras com operação em funcionamento",
        ],
      },
      {
        title: "O que garante eficiência na reforma",
        items: [
          "Planejamento preventivo",
          "Controle de cronograma",
          "Gestão organizada da execução",
          "Segurança operacional",
          "Controle técnico contínuo",
          "Redução de impactos produtivos",
          "Maior previsibilidade da obra",
          "Menos retrabalho",
        ],
      },
    ],
    cta: "Solicitar análise técnica da reforma",
    image: IMAGES.steelFrame,
    seo: {
      title: "Reformas Industriais com Controle Técnico | SCA Construtora",
      description:
        "Modernização, ampliação e adequação de instalações industriais com planejamento técnico, segurança operacional e controle rigoroso da execução.",
    },
  },
  {
    slug: "obras-comerciais",
    number: "03",
    title: "Obras Comerciais",
    short: "Prédios, escritórios e centros comerciais com execução eficiente.",
    h1: "Obras comerciais com organização, funcionalidade e execução eficiente",
    intro:
      "A SCA Construtora atua na construção e adequação de espaços comerciais com foco em planejamento técnico, controle operacional e cumprimento rigoroso de prazos.",
    sections: [
      {
        title: "Principais tipos de obras executadas",
        items: [
          "Prédios comerciais",
          "Escritórios corporativos",
          "Centros comerciais",
          "Lojas e espaços de varejo",
          "Adequações comerciais",
          "Reformas corporativas",
          "Espaços de atendimento",
          "Estruturas operacionais comerciais",
        ],
      },
      {
        title: "O diferencial da SCA na execução comercial",
        items: [
          "Planejamento estruturado",
          "Controle rigoroso de prazos",
          "Gestão eficiente de equipes",
          "Organização operacional",
          "Segurança técnica",
          "Redução de retrabalhos",
          "Controle de qualidade",
          "Transparência no acompanhamento da obra",
        ],
      },
    ],
    cta: "Solicitar orçamento técnico",
    image: IMAGES.commercial,
    seo: {
      title: "Construção de Obras Comerciais | SCA Construtora",
      description:
        "Execução de obras comerciais, corporativas e adequações estruturais com foco em prazo, funcionalidade e qualidade construtiva.",
    },
  },
  {
    slug: "adequacoes-estruturais",
    number: "04",
    title: "Adequações Estruturais",
    short: "Reforços, intervenções técnicas e adaptações com precisão.",
    h1: "Adequações estruturais com precisão técnica e segurança operacional",
    intro:
      "A SCA executa adequações estruturais e intervenções técnicas em edificações industriais, comerciais e operacionais. Esses projetos exigem análise técnica aprofundada, controle rigoroso da execução e planejamento detalhado.",
    sections: [
      {
        title: "Serviços executados",
        items: [
          "Reforços estruturais",
          "Adequações operacionais",
          "Intervenções técnicas",
          "Adaptações estruturais",
          "Melhorias técnicas em edificações",
          "Readequação de layouts estruturais",
          "Adequações conforme normas vigentes",
        ],
      },
      {
        title: "O que a SCA garante",
        items: [
          "Segurança estrutural",
          "Controle técnico rigoroso",
          "Execução organizada",
          "Redução de riscos operacionais",
          "Conformidade normativa",
          "Precisão construtiva",
          "Planejamento preventivo",
        ],
      },
    ],
    cta: "Falar com especialista técnico",
    image: IMAGES.concrete,
    seo: {
      title: "Adequações Estruturais e Intervenções Técnicas | SCA Construtora",
      description:
        "Execução de adequações estruturais, reforços técnicos e intervenções em edificações com segurança e precisão operacional.",
    },
  },
  {
    slug: "obras-residenciais",
    number: "05",
    title: "Obras Residenciais",
    short: "Residências de médio e alto padrão executadas com método industrial.",
    h1: "Obras residenciais executadas com método, controle e qualidade construtiva",
    intro:
      "A SCA Construtora executa obras residenciais de médio e alto padrão com foco em organização, controle técnico e acompanhamento rigoroso da execução.",
    sections: [
      {
        title: "Serviços residenciais executados",
        items: [
          "Construção residencial completa (do projeto à entrega)",
          "Residências personalizadas de médio e alto padrão",
          "Obras de luxo com acabamentos premium",
          "Gerenciamento técnico de execução residencial",
          "Controle de qualidade construtiva em todas as etapas",
          "Coordenação operacional de equipes e fornecedores",
          "Reformas residenciais estruturais e arquitetônicas",
          "Ampliações com integração arquitetônica",
        ],
      },
      {
        title: "O que o cliente recebe",
        items: [
          "Obra organizada com canteiro estruturado",
          "Planejamento físico-financeiro detalhado",
          "Controle de execução com relatórios periódicos",
          "Transparência no acompanhamento (visitas técnicas, fotos, indicadores)",
          "Qualidade construtiva conforme padrão contratado",
          "Redução de desperdícios e custos imprevistos",
          "Segurança técnica e conformidade com normas vigentes",
          "Entrega validada com manual do proprietário",
        ],
      },
    ],
    cta: "Solicitar avaliação do projeto residencial",
    image: IMAGES.residential,
    seo: {
      title: "Construção Residencial de Médio e Alto Padrão | SCA Construtora",
      description:
        "Execução de obras residenciais com planejamento técnico, organização operacional e alto padrão construtivo.",
    },
  },
  {
    slug: "gerenciamento-de-obras",
    number: "06",
    title: "Gerenciamento de Obras",
    short: "Coordenação técnica completa: planejamento, equipes, fornecedores e qualidade.",
    h1: "Gerenciamento técnico e execução completa de obras",
    intro:
      "A SCA Construtora atua no gerenciamento e execução de obras com foco em organização operacional, controle técnico e previsibilidade.",
    sections: [
      {
        title: "Como a SCA gerencia a obra",
        items: [
          "Planejamento físico-financeiro",
          "Gestão de cronograma",
          "Coordenação de equipes",
          "Controle técnico da execução",
          "Gestão de fornecedores",
          "Organização operacional",
          "Controle de qualidade",
          "Monitoramento contínuo da obra",
        ],
      },
      {
        title: "O que a gestão estruturada proporciona",
        items: [
          "Maior previsibilidade",
          "Controle de custos",
          "Cumprimento de prazos",
          "Organização operacional",
          "Menos retrabalho",
          "Melhor produtividade",
          "Transparência técnica",
        ],
      },
    ],
    cta: "Solicitar alinhamento técnico da obra",
    image: IMAGES.management,
    seo: {
      title: "Gerenciamento e Execução de Obras | SCA Construtora",
      description:
        "Planejamento, coordenação e gerenciamento técnico de obras industriais, comerciais e residenciais com controle total da execução.",
    },
  },
];

// ---------- METODOLOGIA ----------
export const METHODOLOGY = [
  {
    n: "01",
    title: "Diagnóstico técnico",
    desc: "Análise completa do projeto, escopo, riscos e condições operacionais.",
  },
  {
    n: "02",
    title: "Planejamento executivo",
    desc: "Estruturação do cronograma, sequência construtiva e estratégia operacional.",
  },
  {
    n: "03",
    title: "Estruturação operacional",
    desc: "Organização de equipes, suprimentos, logística e recursos da obra.",
  },
  {
    n: "04",
    title: "Execução controlada",
    desc: "Acompanhamento técnico contínuo e monitoramento da qualidade.",
  },
  {
    n: "05",
    title: "Controle e monitoramento",
    desc: "Gestão de cronograma, produtividade, qualidade e conformidade.",
  },
  {
    n: "06",
    title: "Entrega validada",
    desc: "Finalização técnica com controle e alinhamento ao escopo aprovado.",
  },
];

// ---------- DIFERENCIAIS ----------
export const DIFFERENTIALS = [
  { icon: "ClipboardList", title: "Planejamento técnico rigoroso", desc: "Cada obra inicia com diagnóstico aprofundado e plano executivo detalhado." },
  { icon: "LayoutGrid", title: "Organização operacional", desc: "Canteiro estruturado, fluxos definidos, equipes coordenadas." },
  { icon: "Timer", title: "Cumprimento de cronograma", desc: "Gestão de prazos por marcos, com controle físico-financeiro semanal." },
  { icon: "HardHat", title: "Gestão eficiente de canteiro", desc: "Logística, suprimentos e produtividade tratados como engenharia aplicada." },
  { icon: "Wrench", title: "Resolução técnica de problemas", desc: "Engenharia ativa: antecipamos riscos e resolvemos com método." },
  { icon: "Eye", title: "Transparência no relacionamento", desc: "Relatórios técnicos, indicadores e comunicação direta com o cliente." },
  { icon: "ShieldCheck", title: "Segurança e conformidade", desc: "Aderência total a normas técnicas e protocolos de segurança." },
];

// ---------- PROJECTS (categorizados) ----------
export const PROJECTS = [
  {
    id: "ind-01",
    title: "Galpão industrial — Linha de produção alimentícia",
    location: "Piracicaba — SP",
    category: "industriais",
    year: "2024",
    area: "8.400 m²",
    image: IMAGES.industrial,
    summary: "Construção de planta industrial completa com estrutura metálica, infraestrutura e adequações operacionais.",
  },
  {
    id: "ind-02",
    title: "Ampliação fabril — Indústria metalúrgica",
    location: "Limeira — SP",
    category: "industriais",
    year: "2023",
    area: "5.200 m²",
    image: IMAGES.steelFrame,
    summary: "Ampliação de 5.200 m² com operação ativa, sem interrupção do processo produtivo.",
  },
  {
    id: "ind-03",
    title: "Centro de distribuição logístico",
    location: "Rio Claro — SP",
    category: "industriais",
    year: "2024",
    area: "12.000 m²",
    image: IMAGES.warehouse,
    summary: "Estrutura metálica de grandes vãos, docas, escritórios técnicos e infraestrutura completa.",
  },
  {
    id: "com-01",
    title: "Edifício corporativo — Sede regional",
    location: "Piracicaba — SP",
    category: "comerciais",
    year: "2023",
    area: "3.800 m²",
    image: IMAGES.commercial,
    summary: "Sede corporativa com acabamento premium, salas técnicas e infraestrutura tecnológica integrada.",
  },
  {
    id: "com-02",
    title: "Centro comercial — Multiuso",
    location: "Americana — SP",
    category: "comerciais",
    year: "2022",
    area: "6.100 m²",
    image: IMAGES.facade,
    summary: "Empreendimento comercial com lojas, escritórios e estacionamento estruturado.",
  },
  {
    id: "ref-01",
    title: "Modernização de planta — Adequação NR-12",
    location: "Piracicaba — SP",
    category: "reformas",
    year: "2024",
    area: "2.400 m²",
    image: IMAGES.metalStructure,
    summary: "Modernização técnica e adequação normativa com obra em operação contínua.",
  },
  {
    id: "ref-02",
    title: "Reforma corporativa — Headquarters",
    location: "Campinas — SP",
    category: "reformas",
    year: "2023",
    area: "1.800 m²",
    image: IMAGES.blueprint,
    summary: "Readequação completa de layouts corporativos com mínimo impacto operacional.",
  },
  {
    id: "case-01",
    title: "Reforço estrutural — Edifício industrial centenário",
    location: "Piracicaba — SP",
    category: "cases-tecnicos",
    year: "2024",
    area: "4.300 m²",
    image: IMAGES.concrete,
    summary: "Intervenção estrutural complexa com preservação de elementos históricos e reforço técnico aprofundado.",
  },
];

export const PROJECT_CATEGORIES = [
  { slug: "todos", label: "Todos" },
  { slug: "industriais", label: "Obras Industriais" },
  { slug: "comerciais", label: "Obras Comerciais" },
  { slug: "reformas", label: "Reformas" },
  { slug: "cases-tecnicos", label: "Cases Técnicos" },
];

// ---------- NOTÍCIAS ----------
export const NEWS = [
  {
    slug: "metodo-x-improviso",
    title: "Método x improviso: o que diferencia obras industriais previsíveis",
    excerpt:
      "Como a organização de canteiro reduz desperdício e aumenta produtividade em obras complexas.",
    image: IMAGES.blueprint,
    date: "10.12.2025",
    tag: "Engenharia",
    readingTime: "6 min de leitura",
    author: "Equipe Técnica SCA",
    body: [
      { type: "p", text: "Em construção civil, a distância entre uma obra previsível e uma obra problemática raramente está no projeto arquitetônico ou no orçamento contratado. Está, quase sempre, no método aplicado ao canteiro. Obras conduzidas por improviso reagem ao problema. Obras conduzidas por método antecipam o problema." },
      { type: "h2", text: "O custo invisível do improviso" },
      { type: "p", text: "Atrasos, retrabalhos, perdas de material, paradas inesperadas e desorganização logística são sintomas — não causas. A causa raiz costuma ser a ausência de um plano executivo detalhado, falta de marcos físicos verificáveis e ausência de governança técnica diária." },
      { type: "p", text: "Quando o canteiro depende de decisões reativas, o custo invisível compromete margens, prazo e qualidade simultaneamente. O improviso parece barato no curto prazo e mostra-se devastador no encerramento." },
      { type: "h2", text: "O que muda quando existe método" },
      { type: "ul", items: [
        "Cronograma físico-financeiro consolidado e atualizado semanalmente",
        "Plano de ataque sequencial por etapa construtiva",
        "Curva de suprimentos sincronizada com a curva de execução",
        "Indicadores de produtividade medidos por frente de trabalho",
        "Reuniões técnicas com pauta, ata e responsáveis nomeados",
        "Controle documental integrado (RDOs, AS-BUILT, ensaios)",
      ]},
      { type: "h2", text: "Como a SCA aplica método em campo" },
      { type: "p", text: "A engenharia SCA atua em seis estágios encadeados — diagnóstico técnico, planejamento executivo, estruturação operacional, execução controlada, controle e monitoramento, entrega validada. Cada estágio possui artefatos próprios, indicadores e ritos de governança. O método não é um documento — é um sistema operacional do canteiro." },
      { type: "quote", text: "A diferença entre uma obra com método e uma obra sem método não é estética. É econômica, técnica e contratual." },
      { type: "p", text: "Se sua próxima obra precisa de previsibilidade, comece pela engenharia que organiza o canteiro antes da primeira escavação." },
    ],
  },
  {
    slug: "nr12-adequacao-estrutural",
    title: "NR-12: adequação estrutural sem parar a produção",
    excerpt:
      "Roteiro técnico aplicado pela SCA em adequações operacionais em plantas industriais ativas.",
    image: IMAGES.metalStructure,
    date: "02.12.2025",
    tag: "Normas",
    readingTime: "7 min de leitura",
    author: "Engenharia SCA",
    body: [
      { type: "p", text: "Adequar uma planta industrial à NR-12 sem interromper a produção é, antes de tudo, um projeto de engenharia logística. A complexidade não está na intervenção em si, mas na coordenação entre intervenção física e operação ativa." },
      { type: "h2", text: "O ponto cego das adequações" },
      { type: "p", text: "Muitas empresas tratam NR-12 como compliance documental. Na prática, a norma exige intervenções físicas reais: proteções, intertravamentos, isolamentos, sinalizações e, frequentemente, reforços estruturais. Cada intervenção tem janelas de execução, requisitos de SST e impacto operacional próprios." },
      { type: "h2", text: "Roteiro técnico SCA para adequação com operação ativa" },
      { type: "ul", items: [
        "Mapeamento de ativos: máquinas, áreas críticas, rotas de pessoas e materiais",
        "Análise de janelas operacionais: paradas programadas, turnos, sazonalidades",
        "Plano de intervenções por frente isolada com tempo máximo controlado",
        "Logística de canteiro segregada da operação produtiva",
        "Protocolos de SST específicos para áreas mistas (obra + operação)",
        "Monitoramento contínuo de indicadores de produção e indicadores de obra",
      ]},
      { type: "h2", text: "O ganho de tratar como projeto de engenharia" },
      { type: "p", text: "Quando a adequação é planejada como engenharia, e não como tarefa, o impacto na produção cai significativamente, o prazo se torna previsível e a documentação de compliance fica robusta para auditoria. O custo total — incluindo custo de oportunidade da produção — reduz-se." },
      { type: "quote", text: "Adequar à NR-12 sem parar a produção não é mais caro. É mais bem coordenado." },
    ],
  },
  {
    slug: "cronograma-fisico-financeiro",
    title: "Cronograma físico-financeiro: a ferramenta que evita surpresa em obra",
    excerpt:
      "Por que controlar prazo e custo simultaneamente é o pilar de uma execução previsível.",
    image: IMAGES.helmet,
    date: "25.11.2025",
    tag: "Gestão",
    readingTime: "5 min de leitura",
    author: "Gestão Técnica SCA",
    body: [
      { type: "p", text: "Cronograma físico controla o tempo. Curva financeira controla o dinheiro. Cronograma físico-financeiro controla a obra. Tratar essas dimensões separadamente é a origem da maioria das surpresas de fim de obra — atrasos sem causa aparente, custos acumulados sem rastreabilidade e medições conflitantes entre cliente e construtora." },
      { type: "h2", text: "O que o instrumento entrega" },
      { type: "ul", items: [
        "Visão integrada de avanço físico (% executado) versus avanço financeiro (% medido)",
        "Detecção precoce de descolamento entre execução e desembolso",
        "Base objetiva para reuniões de obra, eliminando achismo",
        "Curva S real comparada à curva S planejada",
        "Indicador de aderência ao plano (Schedule Performance Index)",
        "Indicador de aderência financeira (Cost Performance Index)",
      ]},
      { type: "h2", text: "Como a SCA opera o cronograma físico-financeiro" },
      { type: "p", text: "O cronograma físico-financeiro é construído na fase de planejamento executivo, validado com o cliente, e atualizado semanalmente em campo com dados reais de campo. A leitura conjunta de SPI e CPI permite decisões corretivas antes que o desvio se torne irreversível." },
      { type: "quote", text: "Obra que não mede prazo e custo simultaneamente perde controle de ambos." },
    ],
  },
  {
    slug: "estrutura-metalica-vs-concreto",
    title: "Estrutura metálica versus concreto: critérios técnicos para decisão",
    excerpt:
      "Análise comparativa entre tipologias estruturais para obras industriais e comerciais.",
    image: IMAGES.steelFrame,
    date: "18.11.2025",
    tag: "Técnico",
    readingTime: "8 min de leitura",
    author: "Engenharia Estrutural SCA",
    body: [
      { type: "p", text: "Escolher entre estrutura metálica e estrutura em concreto não deveria ser uma decisão de preferência. Deveria ser o resultado de uma análise técnica que considera vãos, cargas, prazo, logística, manutenção, custo total da vida útil e características do terreno." },
      { type: "h2", text: "Quando estrutura metálica vence" },
      { type: "ul", items: [
        "Grandes vãos livres (galpões logísticos, hangares, plantas industriais)",
        "Prazo de execução agressivo — pré-fabricação acelera a obra",
        "Necessidade de futura ampliação ou desmontagem",
        "Cargas dinâmicas elevadas (pontes rolantes, equipamentos pesados)",
        "Locais com restrição de canteiro ou difícil acesso",
      ]},
      { type: "h2", text: "Quando concreto vence" },
      { type: "ul", items: [
        "Edificações de múltiplos pavimentos com cargas distribuídas",
        "Necessidade de massa térmica (data centers, indústrias químicas)",
        "Ambientes com agressividade química severa",
        "Disponibilidade ampla de mão-de-obra local",
        "Restrições orçamentárias na fase inicial",
      ]},
      { type: "h2", text: "Soluções híbridas" },
      { type: "p", text: "Em muitos projetos industriais e comerciais, a solução técnica e econômica ótima é híbrida — núcleos rígidos em concreto, fechamentos e coberturas em metálica. A SCA realiza análise comparativa detalhada antes de qualquer recomendação, integrando engenharia estrutural, custo, prazo e manutenção." },
      { type: "quote", text: "A escolha estrutural não é estética. É um trade-off que define custo total da vida útil da edificação." },
    ],
  },
  {
    slug: "obras-com-operacao-ativa",
    title: "Obras com operação ativa: como reduzir impacto produtivo",
    excerpt:
      "Boas práticas para intervenções em ambientes industriais em pleno funcionamento.",
    image: IMAGES.warehouse,
    date: "10.11.2025",
    tag: "Operação",
    readingTime: "6 min de leitura",
    author: "Equipe Operações SCA",
    body: [
      { type: "p", text: "Obras com operação ativa são as mais técnicas que existem em construção civil. O canteiro precisa coexistir com a produção, respeitando rotas, ruídos, particulados, segurança, ritmo e custos da operação que continua acontecendo ao redor." },
      { type: "h2", text: "Os 5 pilares operacionais" },
      { type: "ul", items: [
        "Segregação física rigorosa: barreiras, telas, isolamentos, rotas controladas",
        "Janelas de execução negociadas com a operação por frente de trabalho",
        "Logística de suprimentos fora do horário operacional crítico",
        "Comunicação multi-canal entre supervisor de obra e líder de operação",
        "Indicadores cruzados: produtividade da operação e produtividade da obra",
      ]},
      { type: "h2", text: "Erros comuns que destroem a coexistência" },
      { type: "p", text: "Tratar a operação como obstáculo da obra. Não envolver a equipe operacional no planejamento. Negociar janelas de execução em cima da hora. Subestimar o impacto de ruído, particulado e vibração em equipamentos sensíveis. A SCA antecipa todos esses pontos no plano de ataque." },
      { type: "quote", text: "A obra precisa funcionar para a operação — não a operação funcionar para a obra." },
    ],
  },
  {
    slug: "gestao-de-fornecedores",
    title: "Gestão de fornecedores como vantagem técnica em obras complexas",
    excerpt:
      "Por que a curadoria e gestão de fornecedores impacta diretamente o resultado da obra.",
    image: IMAGES.management,
    date: "03.11.2025",
    tag: "Gestão",
    readingTime: "5 min de leitura",
    author: "Suprimentos SCA",
    body: [
      { type: "p", text: "Em obras complexas, a qualidade da execução é, em grande medida, a qualidade dos fornecedores envolvidos. Fornecedor é extensão técnica do canteiro — não um terceiro distante. A construtora que trata fornecedor como commodity está abrindo mão de uma das maiores alavancas de qualidade e prazo." },
      { type: "h2", text: "Os 4 níveis de gestão de fornecedores SCA" },
      { type: "ul", items: [
        "Curadoria técnica: histórico de obras, certificações, capacidade produtiva",
        "Contratação detalhada: escopo, prazo, qualidade, penalidades, garantias",
        "Acompanhamento operacional: medições, ensaios, reuniões periódicas",
        "Avaliação pós-obra: rating técnico que retroalimenta a curadoria",
      ]},
      { type: "h2", text: "Por que isso vira vantagem competitiva" },
      { type: "p", text: "Fornecedor bem gerido entrega no prazo, com qualidade e sem retrabalho. Isso libera o construtor para focar em engenharia, não em apagar incêndios. O custo da curadoria é uma fração do custo de retrabalho que ela evita." },
      { type: "quote", text: "Em obra, a velocidade de execução depende da confiabilidade de quem fornece — não só de quem executa." },
    ],
  },
];

// ---------- STATS ----------
export const STATS = [
  { value: 12, suffix: "+", label: "Anos de operação técnica" },
  { value: 80, suffix: "+", label: "Obras entregues" },
  { value: 350, suffix: "k m²", label: "Área total construída" },
  { value: 98, suffix: "%", label: "Cumprimento de cronograma" },
];

// ---------- VALUES ----------
export const VALUES = [
  "Profissionalismo",
  "Organização",
  "Clareza e transparência",
  "Compromisso com resultado",
  "Segurança",
  "Ética",
  "Responsabilidade técnica",
];
